
import lazyload from "@/directives/lazyload";
import phone from "@/assets/images/landing/svg/phone-red.svg";
import question from "@/assets/images/landing/svg/question-red.svg";
import man from "@/assets/images/landing/svg/man-red.svg";
import phoneAnim from "@/assets/images/landing/img/phone-anim.png";
export default {
  data() {
    return {
      images: {
        phoneAnim,
      },
      list: [
        {
          image: phone,
          title:
            '<h3>We <span class="span--text-red">Uncover Infidelity</span> in the Digital Age</h3>',
          text:
            `At iFindCheaters, we specialize in uncovering online infidelity. Our unique approach employs advanced search technology to catch cheaters and provide you with answers. If there's an account out there, we will help you search for your spouse on dating sites by email. Within moments, you can access your partner's online dating presence, empowering you to monitor their activity and safeguard yourself.`,
        },
        {
          image: question,
          title: '<h3>Easy <span class="span--text-red">To Use</span> Process</h3>',
          text:
            'We stand apart as the sole online service employing cutting-edge technology to expose cheaters. Through direct access to popular Dating and Alternative Lifestyle Sites, we can identify active profiles of your wife or husband on dating sites. Armed with this information, you gain the insight to make informed decisions about your relationship.',
        },
        {
          image: man,
          title: '<h3>Your <span class="span--text-red">Privacy</span> Matters</h3>',
          text:
            'Rest assured, your privacy is our priority. iFindCheaters offers a 100% anonymous service, allowing you to determine if your partner is cheating without disclosing your identity. Your trust matters to us, and our commitment to confidentiality means your user information remains safeguarded. We will never compromise your privacy or tip-off your partner when you find someone on dating sites by email. ',
        },
      ],
    };
  },
  methods: {
    onClickBlock(e) {
      console.dir(e);
      var options = document.querySelectorAll(".description-list__item");
      var parentEl = e.target.offsetParent;
      options.forEach(function (el) {
        el.classList.remove("active");
      });
      if (parentEl.className === "description-list__item") {
        parentEl.classList.add("active");
      } else if (e.target.className === "description-list__item") {
        e.target.classList.add("active");
      }
    },
  },
  directives: {
    lazyload,
  },
};
